<template>
  <v-dialog
    v-model="opened"
    width="400"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card class="content-container">
      <v-card-title class="headline grey lighten-2 title">
        Email integration
        <v-spacer />
        <v-btn icon @click="$emit('update:opened', false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-list two-line>
        <v-list-tile @click="connectGoogleAccount()">
          <v-list-tile-action>
            <img :src="require('@/assets/google.png')" class="provider-logo" />
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="method-title"
              >Connect a <b>Gmail</b> account</v-list-tile-title
            >
          </v-list-tile-content>

          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile @click="connectMicrosoftAccount()">
          <v-list-tile-action>
            <img
              :src="require('@/assets/microsoft.png')"
              class="provider-logo"
            />
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="method-title"
              >Connect an <b>Outlook</b> account</v-list-tile-title
            >
          </v-list-tile-content>

          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  props: {
    opened: {
      type: Boolean,
    },
  },

  data() {
    return {
      auth2: null,
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },

  methods: {
    loadGoogleSignIn() {
      gapi.load('auth2', () => {
        this.auth2 = gapi.auth2.init({
          client_id: process.env.GOOGLE_CLIENT_ID,
          cookiepolicy: 'single_host_origin',
          scope: this.currentUser.email.includes('@soraban.com')
            ? 'https://mail.google.com/'
            : 'https://www.googleapis.com/auth/gmail.send',
        });
      });
    },

    connectGoogleAccount() {
      if (this.auth2) {
        this.auth2
          .grantOfflineAccess()
          .then(async result => {
            this.$emit('linkAccount', 'google', result.code);
          })
          .catch(error => {
            console.log(error);
          });
      }

      this.$emit('update:opened', false);
    },

    async connectMicrosoftAccount() {
      const response = await API.linkedAccount.getAuthorizationUrl({
        redirectUri: process.env.API_URL + '/linked_accounts/oauth_callback',
        sourceUri: window.location.origin + window.location.pathname,
      });

      const authorizationUrl =
        response.data.authorization_url + '&prompt=select_account';

      window.location.href = authorizationUrl;

      this.$emit('update:opened', false);
    },
  },

  async created() {
    this.loadGoogleSignIn();
  },
};
</script>

<style lang="css" scoped>
.provider-logo {
  width: 24px;
  height: 24px;
}
</style>
